import { render, staticRenderFns } from "./Videocast.vue?vue&type=template&id=bf5f1584"
import script from "./Videocast.vue?vue&type=script&lang=js"
export * from "./Videocast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports